import React from "react";
import ReactDOM from "react-dom";
import "./styles/main.scss";
import App from "./App";

//Redux
import { Provider } from "react-redux";
import { store } from "./redux";

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <App />
    </Provider>
  </React.StrictMode>,
  document.getElementById("root")
);
